import { render, staticRenderFns } from "./TutoredExercises.vue?vue&type=template&id=1507233f&scoped=true"
import script from "./TutoredExercises.vue?vue&type=script&lang=js"
export * from "./TutoredExercises.vue?vue&type=script&lang=js"
import style0 from "./TutoredExercises.vue?vue&type=style&index=0&id=1507233f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507233f",
  null
  
)

export default component.exports